import { useState } from "react";
import { createUserTime } from "../../api/workingHoursApi";
import "./WorkingHoursModal.css";

export default function WorkingHoursModal({
                                              selectedUsers,
                                              days,
                                              onClose,
                                          }) {
    const [entryTime, setEntryTime] = useState("");
    const [leaveTime, setLeaveTime] = useState("");
    const [schedule, setSchedule] = useState({});
    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(false);

    // Apply default time to ALL days
    const applyToAllDays = () => {
        if (!entryTime || !leaveTime)
            return alert("Select time first");

        const newSchedule = {};

        days.forEach((day) => {
            newSchedule[day.id] = {
                entry: entryTime,
                leave: leaveTime,
                enabled: true,
            };
        });

        setSchedule(newSchedule);
        setStep(2);
    };

    const updateDay = (dayId, field, value) => {
        setSchedule((prev) => ({
            ...prev,
            [dayId]: {
                ...prev[dayId],
                [field]: value,
            },
        }));
    };

    const toggleDayEnabled = (dayId) => {
        setSchedule((prev) => ({
            ...prev,
            [dayId]: {
                ...prev[dayId],
                enabled: !prev[dayId].enabled,
            },
        }));
    };

    const handleSubmit = async () => {
        try {
            setLoading(true);

            await Promise.all(
                selectedUsers.flatMap((userId) =>
                    Object.entries(schedule)
                        .filter(([_, value]) => value.enabled)
                        .map(([dayId, value]) =>
                            createUserTime({
                                user_id: userId,
                                week_day_id: Number(dayId),
                                entry_time: value.entry,
                                leave_time: value.leave,
                            })
                        )
                )
            );

            alert("Schedule assigned!");
            onClose();
        } catch (err) {
            console.error(err);
            alert("Error occurred");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div
                className="modal-large"
                onClick={(e) => e.stopPropagation()}
            >
                <h2>Assign Working Hours</h2>

                {step === 1 && (
                    <>
                        <div className="modal-row">
                            <label>Entry Time</label>
                            <input
                                type="time"
                                value={entryTime}
                                onChange={(e) =>
                                    setEntryTime(e.target.value)
                                }
                            />
                        </div>

                        <div className="modal-row">
                            <label>Leave Time</label>
                            <input
                                type="time"
                                value={leaveTime}
                                onChange={(e) =>
                                    setLeaveTime(e.target.value)
                                }
                            />
                        </div>

                        <button
                            className="save-btn-large"
                            onClick={applyToAllDays}
                        >
                            Apply to All Days
                        </button>
                    </>
                )}

                {step === 2 && (
                    <>
                        <div className="schedule-list">
                            {Object.entries(schedule).map(
                                ([dayId, value]) => {
                                    const dayName =
                                        days.find(
                                            (d) =>
                                                d.id ===
                                                Number(dayId)
                                        )?.name;

                                    return (
                                        <div
                                            key={dayId}
                                            className="schedule-item"
                                        >
                                            <div className="schedule-header">
                                                <strong>
                                                    {dayName}
                                                </strong>
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        checked={
                                                            value.enabled
                                                        }
                                                        onChange={() =>
                                                            toggleDayEnabled(
                                                                dayId
                                                            )
                                                        }
                                                    />
                                                    Active
                                                </label>
                                            </div>

                                            {value.enabled && (
                                                <div className="schedule-times">
                                                    <input
                                                        type="time"
                                                        value={
                                                            value.entry
                                                        }
                                                        onChange={(e) =>
                                                            updateDay(
                                                                dayId,
                                                                "entry",
                                                                e.target
                                                                    .value
                                                            )
                                                        }
                                                    />
                                                    <input
                                                        type="time"
                                                        value={
                                                            value.leave
                                                        }
                                                        onChange={(e) =>
                                                            updateDay(
                                                                dayId,
                                                                "leave",
                                                                e.target
                                                                    .value
                                                            )
                                                        }
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    );
                                }
                            )}
                        </div>

                        <button
                            className="save-btn-large"
                            disabled={loading}
                            onClick={handleSubmit}
                        >
                            {loading
                                ? "Saving..."
                                : "Save Schedule"}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}
